import React from "react";
import { CtaButton } from "../CtaButton";
import { SectionHeading } from "../SectionHeading";
import { images } from "../../data/landingContent";
export function SystemIntroSection() {
  return <section className="bg-white px-4 py-14 sm:py-20" data-id="element-287" data-mp="xig6ja348140">
      <SectionHeading eyebrow="A more structured way to approach menopause care" title={<>
            Menopause <em className="text-rose" data-id="element-289" data-mp="5s1y3tdvfgzq">Decision Map™</em>
          </>} intro="Six practical volumes designed to help you organize the clinical assessment process, from the first consultation to follow-up and patient communication." data-id="element-288" data-mp="xgvdjowg8q89" />
      <img src={images.hero} alt="The six volumes of Menopause Decision Map™" className="mx-auto mt-6 w-full max-w-2xl" data-id="element-290" data-mp="er5kp7c8yeiz" />
      <CtaButton className="mt-4" label="Get the complete system for $27" data-id="element-291" data-mp="3i9qk7ox61s0d" />
    </section>;
}